import Vue from "vue"
import { MutationTree, GetterTree } from "vuex"

import { RootState } from "~/store"

export const state = () => ({
  history: [] as string[],
})
export type RoutingState = ReturnType<typeof state>

export const mutations: MutationTree<RoutingState> = {
  SET_PREVIOUS(state, new_route) {
    Vue.set(state, "history", [...state.history, new_route])
  },
}

export const getters: GetterTree<RoutingState, RootState> = {
  PREVIOUS(state) {
    return state.history[state.history.length - 1]
  },
}
